<template>
  <div v-if="loading" class="page-content">
    <Loading />
  </div>

  <div v-else>
    <div class="strip fs-14 between-flex">
      <button 
        v-if="developerData && goBackVisible" 
        class="back-button" 
        @click="goBack"
      >
        <span class="material-symbols-outlined"> arrow_back </span>
      </button>

      <form class="search-box" @submit.prevent="onFormSubmit">
        <SearchAndFilter
          v-model="url"
          :placeholder="$t('Developers.searchLink')"
          :showInput="true"
          :showSelect="false"
          @submitForm="onFormSubmit"
        />
      </form>
    </div>

    <div v-if="developerData" class="app-details">
      <DeveloperInfo
        :developerData="developerData"
      />
    </div>
    <div v-else class="error-message">
      {{ error }}
    </div>
  </div>

  <NotificationComponent
    v-if="notification.show"
    :key="notification.key"
    :type="notification.type"
    :title="notification.title"
    :message="notification.message"
    @closed="!notification.show"
  />
</template>

<script>
import SearchAndFilter from "@/components/user/common/SearchAndFilter.vue";
import Loading from "@/components/user/layout/LoadingComponent.vue";
import DeveloperInfo from "@/components/user/viewComponent/developer/DeveloperInfo.vue";
import NotificationComponent from "@/components/custom/notifications/NotificationComponent.vue";
import { getDeveloper } from "@/api/developer.api";
import { detectPlatform, extractDeveloperId } from "@/ultis/user/functions/storePlatform";

export default {
  name: "DeveloperOverviewComponent",
  components: {
    SearchAndFilter,
    Loading,
    DeveloperInfo,
    NotificationComponent,
  },
  props: {
    goBackVisible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      notification: {
        show: false,
        type: null,
        title: null,
        message: null,
        key: 0,
      },
      url: "",
      developerData: null,
      loading: false,
      error: null,
    };
  },
  methods: {
    async fetchData(url = this.url) {
      this.loading = true;
      this.developerData = null;
      try {
        const response = await getDeveloper(url);
        if (response.data.status) {
          this.developerData = response.data.data;
          this.$emit("toggle-visibility", false);
          this.showNotification("success", "Suceess", response.data.msg);
        } else {
          this.showNotification("error", "Error", response.data.msg);
        }
      } catch (error) {
        this.showNotification("error", "Error", error.response.data.msg);
      } finally {
        this.loading = false;
      }
    },
    async onFormSubmit() {
      const platform = detectPlatform(this.url);
      if (!platform) {
        this.showNotification(
          "hold",
          this.$t("Custom.hold"),
          this.$t("Custom.pleaseCheckYourUrl")
        );
        return;
      }
      const storeId = extractDeveloperId(this.url, platform);

      if (!storeId) {
        this.showNotification(
          "hold",
          this.$t("Custom.hold"),
          this.$t("Custom.pleaseCheckYourUrl")
        );
        return;
      }

      this.$router.replace({
        name: "Developer",
        params: { storeId },
      });
      // await this.fetchData();
    },
    async clearInput() {
      this.url = "";
      this.developerData = null; 
      this.$emit("toggle-visibility", true);
    },
    showNotification(type, title, message) {
      this.notification = {
        show: true,
        key: Date.now(),
        type,
        title,
        message,
      };
    },
    goBack() {
      this.developerData = null; 
      this.$emit("toggle-visibility", true);
      this.url = "";
    },
  },
};
</script>

<style scoped>
.search-box {
  width: 100%;
}

.back-button {
  background: none;
  border: none;
  font-size: 16px;
  padding: 7px;
  color: var(--logo-color);
  border-radius: 50%;
  cursor: pointer;
  margin-right: 10px;
}
.back-button:hover {
  background: var(--hover-color);
  text-decoration: underline;
}
.search-box .input-search {
  margin-right: 10px;
}

@media (max-width: 767px) {
  .search-box {
    width: 100%;
  }
}
</style>
